import { render, staticRenderFns } from "./MallOrderConfirmPage.vue?vue&type=template&id=7884421f&scoped=true"
import script from "./MallOrderConfirmPage.vue?vue&type=script&lang=js"
export * from "./MallOrderConfirmPage.vue?vue&type=script&lang=js"
import style0 from "./MallOrderConfirmPage.vue?vue&type=style&index=0&id=7884421f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7884421f",
  null
  
)

export default component.exports